export default "__VITE_ASSET__CmBztMP8__"